/* eslint-disable */
import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import { soldoutCustomPageListUrl } from "@saleor/soldoutcustompage/urls";
import React from "react";
import { getUserName, maybe } from "../../misc";
import { orderListUrl } from "../../orders/urls";
import { productListUrl, productVariantEditUrl } from "../../products/urls";
import { OrderStatusFilter, StockAvailability } from "../../types/globalTypes";
import HomePage from "../components/HomePage";
import { HomePageQuery } from "../queries";
import languageList from "@saleor/globalConstants.js";

const HomeSection = () => {
  const navigate = useNavigator();
  const { user } = useUser();

  const [language, setLanguage] = React.useState("all");
  const [isSelect, setIsSelect] = React.useState(false);
  const setLanguageHandle = event => {
    setLanguage(event.target.value);
    setIsSelect(true);
  };
  const shop_api_Name = localStorage.getItem("shop_api_Name");
  let shopNameList =
    languageList[shop_api_Name.substring(1, shop_api_Name.length - 1)];
  // shopNameList.length && variables={{ language: `${language}` }}
  return (
    <HomePageQuery
      displayLoader
      variables={shopNameList?.length ? { language: `${language}` } : {}}
    >
      {({ data, loading }) => (
        <HomePage
          disabled={loading}
          isSelect={isSelect}
          language={language}
          setLanguageHandle={setLanguageHandle}
          activities={maybe(() =>
            data.activities.edges.map(edge => edge.node).reverse()
          )}
          sales={maybe(() => data.salesToday?.gross)}
          orders={maybe(() => data.ordersToday?.totalCount)}
          salesyesterday={maybe(() => data.salesYesterday?.gross)}
          ordersyesterday={maybe(() => data.ordersYesterday?.totalCount)}
          orderspendingtoday={maybe(() => data.ordersPendingToday?.totalCount)}
          orderspendingyesterday={maybe(
            () => data.ordersPendingYesterday?.totalCount
          )}
          topProducts={maybe(() =>
            data.productTopToday.edges.map(edge => edge.node)
          )}
          onProductClick={(productId, variantId) =>
            navigate(productVariantEditUrl(productId, variantId))
          }
          onOrdersToCaptureClick={() =>
            navigate(
              orderListUrl({
                status: [OrderStatusFilter.READY_TO_CAPTURE]
              })
            )
          }
          onOrdersToFulfillClick={() =>
            navigate(
              orderListUrl({
                status: [OrderStatusFilter.READY_TO_FULFILL]
              })
            )
          }
          onProductsOutOfStockClick={() =>
            navigate(
              productListUrl({
                stockStatus: StockAvailability.OUT_OF_STOCK
              })
            )
          }
          onProductvariantsOutOfStockClick={() =>
            navigate(soldoutCustomPageListUrl())
          }
          ordersToCapture={maybe(() => data.ordersToCapture.totalCount)}
          ordersToFulfill={maybe(() => data.ordersToFulfill.totalCount)}
          productsOutOfStock={maybe(() => data.productsOutOfStock.totalCount)}
          productvariantsOutOfStock={maybe(
            () => data.productvariantsOutOfStock.totalCount
          )}
          userName={getUserName(user, true)}
          userPermissions={user?.userPermissions || []}
        />
      )}
    </HomePageQuery>
  );
};

export default HomeSection;
